var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.334 4.333v-4h1.333v4h4v1.334h-4v4H4.334v-4h-4V4.333z"
})));
export { SvgPlus as ReactComponent };
export default __webpack_public_path__ + "1023d784652b9634827c18f7cc8091ad.svg";